import { createContext, useContext, ReactNode } from 'react';
import { IReviewer } from '@publishing-engine/domain/models';

interface ExistingReviewersContextValue {
  existingReviewers: IReviewer[] | Pick<IReviewer, 'email'>[];
}

const ExistingReviewersContext = createContext<
  ExistingReviewersContextValue | undefined
>(undefined);

export const ExistingReviewersProvider = ({
  children,
  existingReviewers
}: {
  children: ReactNode;
  existingReviewers: IReviewer[] | Pick<IReviewer, 'email'>[];
}) => {
  return (
    <ExistingReviewersContext.Provider value={{ existingReviewers }}>
      {children}
    </ExistingReviewersContext.Provider>
  );
};

// Hook for consuming the context
export const useExistingReviewersContext = () => {
  const context = useContext(ExistingReviewersContext);
  if (!context)
    throw new Error(
      'useReviewerContext must be used within ExistingReviewersProvider'
    );
  return context;
};
